import { Button, Form, Input, Popover, Select, Space } from 'antd'
import { FC, useContext, useMemo } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import PopoverFooter from '../../../../../components/popover-footer/popover-footer'
import { useGetLacquerTypesQuery } from '../../../../../store/api/lacquer-types-api'
import { EditableCellCtx } from '../../../../../components/editable-cell/editable-cell'
import { useSingleActivePopover } from '../../../../../hooks/use-single-active-popover'

const ACTIVE_SHIPMENT_POPOVER_EVENT = 'shipment-popover-active'

const ShipmentLacquersPopover: FC = () => {
    const ctx = useContext(EditableCellCtx)
    const { open, setOpen, handleOpenChange } = useSingleActivePopover({
        eventName: ACTIVE_SHIPMENT_POPOVER_EVENT,
        onClose: ctx.onCancel,
    })
    const { data } = useGetLacquerTypesQuery()
    const types = data?.data

    //Высчитывает ширину формы типа лака
    const lacquerSelectWidth = useMemo(() => {
        const maxLabelLength = (types ?? []).reduce(
            (max, item) => Math.max(max, item.name?.length ?? 0),
            0
        )
        return Math.max(140, maxLabelLength * 8)
    }, [types])

    const onCancel = () => {
        ctx.onCancel()
        setOpen(false)
    }

    const onSave = () => {
        ctx.onBlur()
        setOpen(false)
    }

    return (
        <Popover
            placement='bottomLeft'
            arrow={false}
            mouseLeaveDelay={0.2}
            open={open}
            trigger='click'
            onOpenChange={handleOpenChange}
            content={
                <div style={{ flex: 1 }}>
                    <Form.List name='lacquers'>
                        {(fields, { add, remove }) => (
                            <Space direction='vertical' style={{ width: '100%' }}>
                                {fields.map(field => (
                                    <Space
                                        key={field.key}
                                        align='baseline'
                                        style={{ width: '100%' }}
                                    >
                                        <Form.Item
                                            name={[field.name, 'type']}
                                            style={{ width: lacquerSelectWidth, marginBottom: 0 }}
                                        >
                                            <Select
                                                placeholder='Тип лака'
                                                options={(types ?? []).map(t => ({
                                                    label: t.name,
                                                    value: t.documentId,
                                                }))}
                                                popupMatchSelectWidth={false}
                                                dropdownStyle={{ minWidth: 320 }}
                                                getPopupContainer={trigger => trigger.parentElement || trigger}
                                                allowClear
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name={[field.name, 'name']}
                                            style={{ width: 140, marginBottom: 0 }}
                                        >
                                            <Input placeholder='Наименование' />
                                        </Form.Item>
                                        <Button
                                            type='text'
                                            danger
                                            onClick={() => remove(field.name)}
                                        >
                                            ×
                                        </Button>
                                    </Space>
                                ))}
                                <Button
                                    type='dashed'
                                    onClick={() => add({ type: undefined, name: '' })}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    Добавить лак
                                </Button>
                                <PopoverFooter onCancel={onCancel} onSave={onSave} />
                            </Space>
                        )}
                    </Form.List>
                </div>
            }
        >
            <div style={{ height: '100%', width: 1 }} />
        </Popover>
    )
}

export default ShipmentLacquersPopover
